module.exports = __webpack_public_path__ + "img/lezhi03.143b3fd5.png";